import SideBarItems from "./SideBarItems";
import { FaFileDownload, FaHome } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import paramarshProfile from "../assets/paramarshLogo.png";
import { Link } from "react-router-dom";

import { useDispatch } from "react-redux";
import { logoutUser } from "../Redux/userSlice";
import { useEffect, useState } from "react";
import { IoIosCall } from "react-icons/io";
import { BASE_IMG_URL } from "../constants";

export default function SideBar({ menu, userData }) {
  // console.log("menu 1",menu);
  const dispatch = useDispatch();
  const [toggleFlag, setToggleFlag] = useState([]);
  const [toggleFlagTest, setToggleFlagTest] = useState([]);
  const handleLogout = () => {
    console.log("test logout");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("formLocalData");
    localStorage.removeItem("productInfo");
    dispatch(logoutUser());
  };

  useEffect(() => {
    let arr = [];

    menu?.map((menuFetch) => {
      arr.push(false);
    });
    setToggleFlag(arr);
  }, [menu]);

  useEffect(() => {
    let arrMenu = [];

    menu?.length > 0 &&
      menu?.map((menuFetch, index) => {
        let tempArr = [];
        let tempArr2 = [];
        let tempArr4 = [];
        menuFetch?.firstData?.length > 0 &&
          menuFetch?.firstData?.map((subMenuFetch1, ind) => {
            let tempArr3 = [];
            subMenuFetch1?.secondData?.length > 0 &&
              subMenuFetch1?.secondData?.map((subMenuFetch2, ind) => {
                let tempArr5 = [];
                subMenuFetch2?.thirdData?.length > 0 &&
                  subMenuFetch2?.thirdData?.map((subMenuFetch3, ind) => {
                    subMenuFetch3?.fourthData.length > 0
                      ? tempArr5.push(false)
                      : tempArr5.push(null);
                  });
                tempArr4.push(tempArr5);
                subMenuFetch2?.thirdData.length > 0
                  ? tempArr3.push({ parent: false, child: tempArr5 })
                  : tempArr3.push(null);
              });
            tempArr2.push(tempArr3);
            subMenuFetch1?.secondData.length > 0
              ? tempArr.push({ parent: false, child: tempArr3 })
              : tempArr.push({ parent: null, child: null });
          });
        arrMenu.push({ parent: false, child: tempArr });
      });
    setToggleFlagTest(arrMenu);
  }, [menu]);
  return (
    <>
      <div className="sidebar">
        <Link to={"/"} className="sidebar-item plain">
          <p className="flex items-center">
            <FaHome />
            &nbsp; Dashboard
          </p>
        </Link>

        {menu.map((child, index) => (
          <SideBarItems
            key={index}
            prefix={"/"}
            menu={child}
            menuIndex={index}
            toggleFlag={toggleFlagTest}
            toggMenuFlagArr={setToggleFlagTest}
            menuLevel={1}
          />
        ))}

        {/* <Link to={"/reportdownloadlink"} className="sidebar-item plain">
          <p className="flex items-center">
            <FaFileDownload />
            &nbsp; Report Download Links
          </p>
        </Link> */}
        <Link to={"#"} onClick={handleLogout} className="sidebar-item plain">
          <p className="flex items-center">
            <FiLogOut />
            &nbsp; Log Out
          </p>
        </Link>
      </div>

      <div className="sidebar-logo-box rounded-10" >
        <div className="row " style={{ fontSize: "13px" }}>
          <div className="col-md-5 ">
            <img
              src={ userData?.profileImagePath?`${BASE_IMG_URL}${userData?.profileImagePath}`: paramarshProfile}
            
              alt="Profile Image "
              className="user-profile"
            />
          </div>
          <div className="col-md-7 text-navyBlue">
            <div className="text-center ">
              {" "}
             <strong>{userData?.usertype == "expert"
                ? userData?.expertName
                : userData?.username}</strong> 
            </div>
            {userData?.usertype === "expert" ? (
              <div className="text-center"> {`( ${userData?.domainName} )`}</div>
             
            ) : (
              <></>
            )}
            {userData?.usertype === "admin" ? (
              <></>
            ) : (
              <>
                {" "}
                <div className="text-center">{<IoIosCall/>} {userData?.phone} </div>
              </>
            )}
          </div>

          {/* <div className="col-md-12">
            <Link to={"#"} onClick={handleLogout}>
              <p className="flex items-center text-center btn btn-outline-secondary rounded-10">
                <FiLogOut />
                &nbsp; Log Out
              </p>
            </Link>{" "}
          </div> */}
        </div>
      </div>
    </>
  );
}
